// extracted by mini-css-extract-plugin
module.exports = {"customer-prescription-count":"customerPrescriptionCount_customer-prescription-count__iNdJm","counter":"customerPrescriptionCount_counter__Ofa5N"};